import React from 'react';
import ErrorBoundary from 'components/ErrorBoundary';
import AppBar from 'components/AppBar/AppBar';
import Header from 'components/Header/Header';
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import {dashRoutes, deviceRoutes, adminRoutes, truckRoutes, tagSchemeRoutes, reportRoutes} from "utils/routes";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import Login from "pages/Login/Login";
import ToastManager from "./common/ToastManager";
import BusyLoader from "./common/BusyLoader";

interface AppProps {
}


const App: React.FC<AppProps> = () => {
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();


  return (
    <>
      <ToastManager />
      <BusyLoader />
      {
        isAuthenticated ?
          <Router>
            <AppBar>
              <Header />
              <ErrorBoundary>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" />} />
                  {[...dashRoutes, ...deviceRoutes, ...truckRoutes,...tagSchemeRoutes,...reportRoutes,...adminRoutes].map((r, i) => <Route key={i} path={r.route} element={r.element} />)}
                </Routes>
              </ErrorBoundary>
            </AppBar>
          </Router>
          :
          <Login />
     }
    </>

  )
}

export default App;